<template>
  <div class="laypanel">
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="订单日期:">
            <el-date-picker
              v-model="byorderdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="queryjzorder">查询订单</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        show-summary
        :data="jzorderdata"
        ref="multipleTable">
        <el-table-column
          prop="orderno"
          width = "200px"
          label="订单编号">
        </el-table-column>
        <el-table-column
          prop="tradeno.String"
          width = "200px"
          label="支付单号">
        </el-table-column>
        <el-table-column
          prop="countprice"
          width = "120px"
          label="进账金额">
        </el-table-column>
        <el-table-column
          prop="name.String"
          label="用户">
        </el-table-column>
        <el-table-column
          prop="optime"
          label="下单时间">
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看订单详情" placement="top-start">
              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seeorder(scope.$index, jzorderdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="订单详情" :visible.sync="orderdetailvisible">
      <div class="showpcinfo">
        <el-table
          stripe
          show-summary
          :data="orderdetaildata"
          ref="multipleTable">
          <el-table-column
            label="图片">
            <template slot-scope="scope">
              <div v-if="scope.row.imgurl.Valid && scope.row.imgurl.String !== ''">
                <img :src="scope.row.imgurl.String" class="goodsavatarimg">
              </div>
              <div v-else>
                {{scope.row.imgurl.String}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="barcode.String"
            label="产品编码">
          </el-table-column>
          <el-table-column
            prop="name.String"
            width = "280px"
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="gspecname.String"
            label="规格">
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价">
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'FxOrder',
  data () {
    return {
      jzorderdata: [],
      orderdetaildata: [],
      khid: '',
      byorderdate: '',
      orderdetailvisible: false
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
    }
  },
  methods: {
    queryjzorder () {
      var qstr = 'sale_cus_id =' + this.khid + ' and state_id>=2'
      if (this.byorderdate !== null && this.byorderdate !== '') {
        qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59' "
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/goi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by op_time desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.jzorderdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeorder (index, data) {
      var ddata = data[index]
      this.orderdetailvisible = true
      var qstr = "order_no ='" + ddata.orderno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/god',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.orderdetaildata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/finance/ZDInput.vue